import Page from '@/model/Page';
import Contractor from '@/model/Contractor';
import Bank from '@/model/Bank';
import User from '@/model/User';

export type ContractorResponse = Page<Contractor, Contractor>;

export type ContractorRequestParams = Pick<
  Page<Contractor, Contractor>,
  'page' | 'pageSize' | 'order' | 'sort' | 'total'
>;

export type ContractorControllerBankAccount = {
  banks: Bank[];
  handleAddBanckAccount(): void;
  handleChangeBanckAccount(inputName: string, index: number, event: string): void;
  handleRemoveBanckAccount(index: number): void;
  bankAccount: any[];
  setBankAccount: React.Dispatch<React.SetStateAction<any[]>>;
};

export type ContractorControllerUser = {
  listUsers: User[];
  usersSelected: User[];
  handleAddUser(userId: string): void;
  handleRemoveUser(index: number): void;
  handleGetUsers: () => Promise<void>;
};

export type BanckAccountForm = {
  id: string;
  name: string;
  agencia: string;
  conta: string;
};

// eslint-disable-next-line no-shadow
export enum FormInputNamePix {
  id = 'id',
  key = 'key',
  pixKeyType = 'pixKeyType',
  bankId = 'bankId',
  recipient = 'recipient',
}

// eslint-disable-next-line no-shadow
export enum FormInputNameFee {
  ticketPhysicalSaleId = 'ticketPhysicalSaleId',
  ticketPhysicalSaleDebit = 'ticketPhysicalSaleDebit',
  ticketPhysicalSaleCredit = 'ticketPhysicalSaleCredit',
  ticketPhysicalSalePix = 'ticketPhysicalSalePix',
  ticketPhysicalSaleAdministrateTax = 'ticketPhysicalSaleAdministrateTax',
  ticketPhysicalSaleInstallments = 'ticketPhysicalSaleInstallments',
  ticketPhysicalSaleFee = 'ticketPhysicalSaleFee',
  ticketWebsiteSaleId = 'ticketWebsiteSaleId',
  ticketWebsiteSaleBankSlip = 'ticketWebsiteSaleBankSlip',
  ticketWebsiteSaleCredit = 'ticketWebsiteSaleCredit',
  ticketWebsiteSalePix = 'ticketWebsiteSalePix',
  ticketWebsiteSaleAdministrateTax = 'ticketWebsiteSaleAdministrateTax',
  ticketWebsiteSaleInstallments = 'ticketWebsiteSaleInstallments',
  ticketWebsiteSaleFee = 'ticketWebsiteSaleFee',
  productPhysicalSaleId = 'productPhysicalSaleId',
  productPhysicalSaleDebit = 'productPhysicalSaleDebit',
  productPhysicalSaleCredit = 'productPhysicalSaleCredit',
  productPhysicalSalePix = 'productPhysicalSalePix',
  productPhysicalSaleAdministrateTax = 'productPhysicalSaleAdministrateTax',
  productPhysicalSaleInstallments = 'productPhysicalSaleInstallments',
  productPhysicalSaleFee = 'productPhysicalSaleFee',
  productWebsiteSaleId = 'productWebsiteSaleId',
  productWebsiteSaleBankSlip = 'productWebsiteSaleBankSlip',
  productWebsiteSaleCredit = 'productWebsiteSaleCredit',
  productWebsiteSalePix = 'productWebsiteSalePix',
  productWebsiteSaleAdministrateTax = 'productWebsiteSaleAdministrateTax',
  productWebsiteSaleInstallments = 'productWebsiteSaleInstallments',
  productWebsiteSaleFee = 'productWebsiteSaleFee',
}

// eslint-disable-next-line no-shadow
export enum FormInputTaxes {
  calcAdmFee = 'calcAdmFee',
  pdv = 'pdv',
  generalCommission = 'generalCommission',
  credit = 'credit',
  installment = 'installment',
  debit = 'debit',
  pix = 'pix',
  bankslip = 'bankslip',
  food = 'food',
  technical = 'technical',
  trip = 'trip',
  rentPos = 'rentPos',
  courtesyIssuance = 'courtesyIssuance',
  cashSaleDashboard = 'cashSaleDashboard',
  ticketCancellations = 'ticketCancellations',
  blockMap = 'blockMap',
  releaseMap = 'releaseMap',
  ticketRoll = 'ticketRoll',
  calcAdmFeeProduct = 'calcAdmFeeProduct',
  pdvProduct = 'pdvProduct',
  generalCommissionProduct = 'generalCommissionProduct',
  creditProduct = 'creditProduct',
  installmentProduct = 'installmentProduct',
  debitProduct = 'debitProduct',
  pixProduct = 'pixProduct',
  bankSlipProduct = 'bankSlipProduct',
  foodProduct = 'foodProduct',
  technicalProduct = 'technicalProduct',
  tripProduct = 'tripProduct',
  rentPosProduct = 'rentPosProduct',
  courtesyIssuanceProduct = 'courtesyIssuanceProduct',
  cashSaleDashboardProduct = 'cashSaleDashboardProduct',
  ticketCancellationsProduct = 'ticketCancellationsProduct',
  ticketRollProduct = 'ticketRollProduct',
}
